import React, {useEffect} from "react";
import {useCartContext} from "../../cart/CartContextProvider/CartContextProvider";
import {getShopId} from "../getShopId";
import window from "../WindowExtended";
import {
  amazonClientId,
  amazonMerchantId,
  amazonPayButtonId,
  amazonPayScriptId,
  amazonScriptSourceUrl,
  isAmazonLoggedIn,
} from "./AmazonPayLibrary";
import {Payments, paypalLocales} from "./PaymentController";
import {useCustomerContext} from "../../customer/CustomerContextProvider/CustomerContextProvider";
import {CheckoutFactory} from "@connox/typescript-library";

const AmazonPayButtonReact: React.FC<{onReturn: () => void; handleError: (err: Error) => void}> = (props) => {
  const {customer} = useCustomerContext();
  const context = useCartContext();

  useEffect(() => {
    const existingButton = document.getElementById("AmazonPayButtonReact");
    const isInitialized = existingButton && !!existingButton.childNodes.length;

    if (!context.isCartVisible || isInitialized || customer.isLoggedIn || getShopId() !== 100001) {
      return;
    }

    const onAmazonLoginReady = () => {
      try {
        window.amazon.Login.setClientId(amazonClientId);
        window.amazon.Login.setUseCookie(true);
      } catch (err) {
        props.handleError(err);
        if (__DEVELOPMENT__) {
          // eslint-disable-next-line no-console
          console.error(err);
        }
      }
    };
    window.onAmazonLoginReady = onAmazonLoginReady;

    const onAmazonPaymentsReady = () => {
      window.OffAmazonPayments.Button(amazonPayButtonId, amazonMerchantId, {
        authorization: () => {
          /* POPUP INITIALIZATION */
          const loginOptions = {
            popup: true,
            scope: "profile payments:widget payments:billing_address payments:shipping_address",
          };
          window.amazon.Login.authorize(loginOptions, (response) => {
            /* AFTER LOGIN */
            if (response.error) {
              props.handleError(new Error(response.error_description));

              return;
            }
            window.accessToken = response.access_token;
          });
        },
        color: "Gold",
        language: paypalLocales[getShopId()],
        onError: (err) => {
          props.handleError(new Error(`${err.getErrorCode()}: ${err.getErrorMessage()}`));
        },
        onSignIn: async (orderReference) => {
          /* AFTER LOGIN */
          window.orderReferenceId = orderReference.getAmazonOrderReferenceId();
          try {
            const checkout = await CheckoutFactory.generateCheckout(getShopId(), context.cart);
            await checkout.put({paymentId: Payments.AmazonPay});
            props.onReturn();
          } catch (e) {
            props.handleError(e);
          }
        },
        size: "medium",
        type: "PwA",
      });
    };
    window.onAmazonPaymentsReady = onAmazonPaymentsReady;

    const scriptNode = document.getElementById(amazonPayScriptId);
    if (scriptNode) {
      onAmazonPaymentsReady();

      return;
    }

    const script = document.createElement("script");
    script.id = amazonPayScriptId;
    script.type = "text/javascript";
    script.src = amazonScriptSourceUrl;
    script.async = true;

    document.body.appendChild(script);
  }, []);

  if (!context.isCartVisible || customer.isLoggedIn || getShopId() !== 100001) {
    return null;
  }

  return (
    <div
      id={amazonPayButtonId}
      className="center"
      style={{width: "100%", marginTop: isAmazonLoggedIn() ? ".5rem" : "initial"}}
    >
      {/* to be filled by amazon pay */}
    </div>
  );
};

export default AmazonPayButtonReact;
